// Formatting shared by every surface of the sponsor report. The rules live on
// the server (SponsorStatsDaily) — a null CTR already means "below threshold".

export function formatCount(n: number): string {
  return n.toLocaleString();
}

export function formatCtr(ctr: number | null): string {
  return ctr == null ? "—" : `${ctr.toFixed(2)}%`;
}

/** "2026-09-05" → "Sep 5", without letting the browser shift the day across a time zone. */
export function formatDay(iso: string, withYear = false): string {
  const [year, month, day] = iso.split("-").map(Number);
  const date = new Date(year, month - 1, day);
  return date.toLocaleDateString(undefined, {
    month: "short",
    day: "numeric",
    ...(withYear ? { year: "numeric" } : {}),
  });
}
